import React from 'react';
import fr from 'facet-rest';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { buildModalQuery } from 'Consts/ModalQueries';
import { REAL_ASSET_QUERY_VALUE_ID } from 'Consts/RealAssets';
import { openURLInNewTab } from 'Helpers/Navigation';
import OnClickItem from './OnClick';
import DropdownItem from './Dropdown';

const ListItem = ({ item, ...rest }) => {
  if (item && item.items) {
    return (
      <DropdownItem
        {...item}
        {...rest}
      />
    );
  }

  let onClick;
  if (item.resource.relationship('managedAccount')) {
    onClick = () => {};
  } else if (item.category === 'real') {
    onClick = () => {
      const realAssetQuery = {};
      realAssetQuery[REAL_ASSET_QUERY_VALUE_ID] = item.id;
      openModal(buildModalQuery(modalConsts.realAssetModal, realAssetQuery));
    };
  } else {
    onClick = () => {
      item.resource.withRelationship(
        fr.relationships.edit.name,
        (rel) => openURLInNewTab(rel.link('related').url()),
        () => null,
      );
    };
  }

  return (
    <OnClickItem
      {...item}
      {...rest}
      onClick={onClick}
    />
  );
};

export default ListItem;
